import { Injectable } from '@angular/core';
import { Link } from './sidenav.component';






@Injectable()
export class SideNavService {
  navigation: Link[];
  getNavigationList(): Link[] {
    return this.navigation;
  }


}
